import styled from "styled-components";

const NavBarStyle = styled.div` 
  .upper_lower_div {
    gap: 15px; 
    ul li {
      .cart_title.font_change,
      & * {
        font-family: var(--common-font);
        font-size: 18px;
        cursor: pointer;
      } 
    }
    .d-flex {
      align-items: center;
      color: #000;  
      border: 1px solid #fff;
      background: #c5c5c5;
      border-radius: 40px; 
      max-width: 315px;
      width: 100%;
      justify-content: flex-end;
      input[type="text"] {
          border: none;
          background: none;
          padding: 10px;
          @media (max-width: 1199.98px){
            width: 100%;
          }
         }
      button {
        color: var(--green);
        font-size: 18px;
        font-family: var(--common-font);
        background: #fff;
        text-transform: uppercase;
        border-radius: 30px;
        width: 100%;
        min-width: 100px;
        height: 100%;
        padding: 7px 25px;
        border: none;
      }
    }
  }
   
  .header-section {
    /* background-image: ${(props) => `url(${props.image})`}; */
     padding: 20px 0px;
     position: fixed;
      top: 0;
      right: 0;
      left: 0;
      z-index: 999;
      /* background: linear-gradient(90deg, #e0e4e6 0%, #c0cbd1 100%); */
      background: linear-gradient(90deg,#e6e9eb89 0%,#d0d6da9c 100%);
      backdrop-filter: blur(18px);
      width: 100%;
      max-width: 100%;
      @media (max-width: 767px){
        padding: 10px 0;
      }
  }
   
  .header-section ul.nav.navbar-nav.navbar-left li a{
    font-size: 18px;
    line-height: 1.42857143;
    padding: 0;
    color: #000;
    &:hover {
    text-decoration: none;
    outline: none;
    color: #000;
  }
  @media (max-width: 1199.98px){
    color: #fff;
  }
  } 
  
  .header-section ul.nav.navbar-nav.navbar-left {
    display: flex;
    gap: 30px;
    align-items: center;
    justify-content: flex-start;
    @media (max-width: 1280px){
      gap: 13px;
      justify-content: center;
    }
    @media (max-width: 1199.98px){
      gap: 10px;
      margin: 0;
    } 
    @media (max-width: 767px){
      gap: 5px; 
    } 
    button {
    border-radius: 23px;
    background-image: linear-gradient(90deg, #fbd709 0%, #e94f24 100%); 
    font-family: var(--common-font);
    padding: 10px 25px;
    font-size: 18px;
    transition: 0.3s ease all;

    @media only screen and (max-width: 1199px) {
      padding: 8px 15px;
      margin-top: 5px;
    }

    @media only screen and (max-width: 767px) {
      font-size: 16px;
    }

    &:hover {
          text-decoration: none;
          outline: none;
          color: #fff;
          background-size: 150%;
          background-position-x: 50%; 
          a{
            color: #fff; 
          } 
        }
      a{
        color: #fff; 
      } 
      
    }

    &:before,&::after{
      display: none;
    }

  }

    ul.nav.navbar-nav.navbar-left li{
        ul {
        list-style: none;
        margin: 0;
        padding: 0;
        background: var(--green);
        -webkit-border-radius: 10px;
        border-radius: 0;
        padding: 15px 0 30px;
        position: absolute;
        left: 0;
        top: 95px;
        min-width: 200px;
        display: none;
        z-index: -1;
        overflow: hidden; 
          li {
          padding: 5px 20px;
          cursor: pointer;
          color: #000;
        }
      }
    }
 
  ul.nav.navbar-nav.navbar-left > li:hover ul {
    display: block;
  }
  .header-section .navbar { 
    background: transparent;
    border: none;margin-bottom: 0
  } 
  .upper_lower_div {
    float: right;
    display: flex;
    flex-direction: column;
    max-width: 430px;
    width: 100%;
    align-items: flex-end; 
    @media (max-width: 1280px){
      max-width: max-content;
      flex: 100%;
      margin-right: 0;
    margin-left: auto;
    } 
    @media (max-width: 1199.98px){
      max-width: 100%; 
    }
    ul {
      &.navbar-top {
        margin-bottom: 7px;
        li { 
          display: flex;
          &:first-child {
            a {
              padding-left: 5px;
              padding-bottom: 5px;
              @media (max-width: 1024px) {
                padding: 0;
              }
            }
          }
          a {
            padding-top: 5px;
            padding-bottom: 5px;
            color: #fff; 
          }
          span {
            color: #fff;
            padding-top: 9px;
            @media (max-width: 1024px) {
              padding: 0;
              margin: 0 10px;
            }
          }
        }
      }
    }
  }
 
  .upper_lower_div {
          li.wishlist_section.from_navBar_section {
            a {
              padding: 0;
            }
          }
          div input[type="text"]{
            width:100%;
          }
      }

  nav.navbar.navbar-default {
    display: flex;
    align-items: center;
    width: 100%; 
  }

  ul.products_pop_class:before {
    content: "";
    height: 5px;
    width: 100%;
    position: absolute;
    top: 0;
    filter: blur(5px);
    backdrop-filter: blur(5px);
    z-index: -1;
    background: #000000ad;
  }
  .collapse.navbar-collapse {
    max-width: calc(100% - 118px);
    flex: calc(100% - 118px);
    width: 100%;
    justify-content: flex-end;
    align-items: center;
    padding-right: 0; 
    display: flex !important;
    padding-left: 50px;
    @media (max-width: 1280px){
    padding-left: 0;
    justify-content: flex-start;
    }

  }
  .navbar-header {
    max-width: 118px;
    width: 100%;
    flex: 118px;
    img{
      max-width: 100%;
      @media (max-width: 1280px){
        max-width: 100px;
      }
      @media (max-width: 767px){
        max-width: 65px;
      }
    }
    .close {
      display: none;
    }
}
  ul.nav.navbar-nav.navbar-left {
    max-width: calc(100% - 380px);
    flex: calc(100% - 380px);
    width: 100%; 
  } 
  .upper_lower_div ul.nav.navbar-nav.navbar-right {
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: max-content;
    gap: 15px;
    margin: 0;
    & :before,& ::after{
      display: none;
    }
    @media (max-width: 1199.98px){ 
      flex-wrap: wrap;
      width: 100%;
      max-width: 100%;
      justify-content: flex-start; 
      gap: 10px;

        li{
        width: 100%;
        flex: 100%;
        a{
          color: #fff;
        }
      }
    }  

    @media (max-width: 767px){
      gap: 5px;
    }

      button.MuiButtonBase-root {
      color: var(--green);
      gap: 8px;
      font-size: 16px;
      :is(:hover,:focus) {
      border-radius: 0;
      background: none;
      } 
      }
}
@media (max-width: 1199px){
.navbar-default{
   button[type="button"] {
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%); 
    margin: 0px;
    width: 50px;
    background: linear-gradient(90deg, rgb(251, 215, 9) 0%, rgb(233, 79, 36) 100%);
    display: block;
    text-shadow: none;
    color: #fff; 
    height: 50px;
    opacity: 1; 
    border-radius: 5px;
    border: 1px solid #fff;
    .icon-bar {
    width: 100%;
    height: 4px;
    background: #fff;
    @media (max-width: 767px){
      height: 3px;
    }
}
@media (max-width: 767px){
  height: 40px;
  width: 45px;
}
}
}
.collapse.navbar-collapse.hide {
    display: none !important;
}
.collapse.open_collapse_nav {
    position: absolute;
    top: 130px;
    background: var(--site-purple);
    width: 100%;
    left: 0px;
    padding: 30px;
    border-top: 0px;
    max-width: 100%;
    flex: 1 1 100%;
    /* background: linear-gradient(90deg,#e0e4e68a 0%,#c0cbd19c 100%); */
    backdrop-filter: blur(8px);
    flex-wrap: wrap;

    @media (max-width: 767px) {
      top: 80px;
      padding: 20px 15px;
    }
}
.collapse.open_collapse_nav {
    /* display: block !important; */
    display: flex !important;
    flex-direction: column-reverse;
}
.navbar-header {
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    padding-left: 15px;
}
.header-section ul.nav.navbar-nav.navbar-left {
    padding-left: 0px;flex: 1 1 100%;
    max-width: 100%;
    flex-wrap: wrap;
    margin-top: 5px;

    li {
    width: 100%;
}
}
.upper_lower_div {
    float: right;
    display: flex;
    flex-direction: column;
    max-width: 100%;
    width: 100%;
    align-items: flex-end;
    /* margin-top: 15px; */
    margin-top: 0px;
    flex-wrap: wrap;
    
    .d-flex{
      margin-left: 0;
      margin-right: auto;
    }
}
.header-section .container{
  padding: 0;
}
} 
.navbar-nav>li a.text_underAnchor {
  font-size: 12px !important;
  font-weight: 600;
  margin: 0;
  margin-top: 10px;
  line-height: 1.2 !important;
  position: absolute;
  text-align: center;
  font-style: italic;
  /* text-decoration: underline; */

  @media only screen and (max-width:1199px) {
    position: static;
    text-align: left;
  }
}
`;

export default NavBarStyle;
